import actionTypes from '../constants/action-types';

const setAutocompleteData = (prefix, options) => ({
  type: actionTypes.SET_AUTOCOMPLETE_DATA,
  payload: {
    prefix,
    options,
  },
});

export default setAutocompleteData;
